import React from 'react';
import SEO from '../common/SEO';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import FooterOne from '../common/footer/FooterOne';
// import HeaderOne from '../common/header/HeaderOne';
import BreadCrumbOne from '../elements/breadcrumb/BreadCrumbOne';
import FormTwo from '../component/contact/FormTwo';
import HeaderFour from '../common/header/HeaderFour';
import { useTranslation } from 'react-i18next';

const Contact = () => {
    const { t } = useTranslation();

    return (
        <>
            <SEO title="Contact" />
            <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderFour />
                <BreadCrumbOne
                    title="Contact"
                    page="Contact"
                />

                <div className="section section-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-5 col-lg-6">
                                <div className="contact-form-box shadow-box mb--30">
                                    <p className="title h3">{t('Get a quote now')}</p>
                                    <FormTwo />
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6 offset-xl-1">
                                <div className="contact-form-box mt_md--0 mt--150">
                                    <p className="title h4">{t('Téléphone')}</p>
                                    <p>{t('Disponible tous les jours 24h/24')}</p>
                                    <p className="phone-number h4">
                                        <a href={`tel:${process.env.REACT_APP_CONTACT_PHONE2}`}>{process.env.REACT_APP_CONTACT_PHONE}</a>
                                    </p>
                                </div>
                                <hr style={{ margin: 0 }}></hr>
                                <div className="contact-form-box mb--30">
                                    <p className="title h4">{t('Email')}</p>
                                    <p>{t('Entraremos em contacto consigo o mais rapidamente possivel.')}</p>
                                    <p className="phone-number h4">
                                        <a href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}>
                                            {process.env.REACT_APP_SUPPORT_EMAIL}
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul className="list-unstyled shape-group-12">
                        <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/bubble-2.webp"} width="150" height="150" alt="Bubble" /></li>
                        <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/bubble-1.webp"} alt="Bubble" /></li>
                        <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/circle-3.webp"} alt="Circle" /></li>
                    </ul>
                </div>


                <FooterOne parentClass="pt--100 pt_lg--100 pt_md--80 pt_sm--60" />
            </main>
        </>
    )
}

export default Contact;